'use strict'

import ApiClient from './ApiClient'

export default class AttachsizeSettingRepository {
  /**
   * 添付ファイルサイズ設定取得
   * @returns {*}
   */
  get () {
    return ApiClient().get(`/attachsizesettings`)
  }

  /**
   * 添付ファイルサイズ設定更新
   * @param params 添付ファイルサイズ
   * @returns {*}
   */
  put (params) {
    return ApiClient().put(`/attachsizesettings`, params)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/AttachsizeSettingRepository.js